<template>
  <div>
    <form-wizard
      class="quick-signin-wizard"
      ref="quick_signin_wizard"
      color="none"
      step-size="xs"
    >
      <tab-content>
        <TabContentOne
          @isUserFormInvalid="isUserFormInvalid"
          @apiChecksLoading="apiChecksLoading"
          @setIsNewUser="setIsNewUser"
          @setUserDetails="setExisintgUserInfo"
          @newUserInfo="setNewUserInfo"
        />
      </tab-content>

      <tab-content>
        <TabContentTwo
          v-if="loadSiteAndAreaComponent"
          :isNewUser="isNewUser"
          :existingUserInfo="existingUserInfo"
          :newUserInfo="newUserInfo"
          :key="componentTwoKey"
          @setAreaLoginMode="setWizardButtonValue"
          @userCheckinFormInvalid="userCheckinFormInvalid"
          @signInOutFormSubmitted="signInOutFormSubmitted"
        />
      </tab-content>
      <!-- start:: Footer -->
      <div
        slot="footer"
        slot-scope="props"
        class="vp-mt-40 vp-mb-15 d-flex flex-row-reverse justify-content-between"
      >
        <wizard-button
          class="sign-in-btn"
          @click.native="
            props.nextTab(),
              onSubmitForm(props.activeTabIndex),
              toggleLoadSiteAndAreaComponentFlag('next', props.activeTabIndex)
          "
          :disabled="
            isUserFormInvalidFlag ||
            loadingApiChecksSatatus ||
            (isCheckinFormInvalid && props.activeTabIndex > 0) ||
            getIsQuickSignInSubmitClicked
          "
          :class="{
            'vp-width-416': props.activeTabIndex == 0,
            'vp-width-348': props.activeTabIndex > 0,
          }"
        >
          <span>{{ wizardButtonValue }}</span>
          <svg
            v-if="props.activeTabIndex == 0"
            class="vp-ml-8"
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="{transform: savedLang === 'ar' ? 'scaleX(-1)' : ''}"
          >
            <path
              d="M0.499999 7.875L11.1487 7.875L6.2575 12.7663L7.5 14L14.5 7L7.5 6.11959e-07L6.26625 1.23375L11.1487 6.125L0.499999 6.125L0.499999 7.875Z"
              fill="white"
            />
          </svg>
        </wizard-button>

        <wizard-button
          v-if="props.activeTabIndex > 0"
          @click.native="
            navigateToUserForm(props.activeTabIndex),
              toggleLoadSiteAndAreaComponentFlag('prev', props.activeTabIndex)
          "
          class="back-btn"
          :disabled="getIsQuickSignInSubmitClicked"
          :style="props.fillButtonStyle"
        >
          <svg
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="{transform: savedLang === 'ar' ? 'scaleX(-1)' : ''}"
          >
            <path
              d="M27.7789 15.704H11.451L18.9508 8.20423L17.0457 6.3125L6.3125 17.0457L17.0457 27.7789L18.9374 25.8872L11.451 18.3873H27.7789V15.704Z"
              fill="white"
            />
          </svg>
        </wizard-button>
      </div>
      <!-- start:: Footer -->
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import TabContentOne from "./TabContent/TabContentOne.vue";
import TabContentTwo from "./TabContent/TabContentTwo.vue";
import { mapActions, mapGetters } from "vuex";
import { toUpper } from "lodash";

export default {
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    TabContentOne,
    TabContentTwo,
  },
  data() {
    return {
      savedLang: "en",
      isUserFormInvalidFlag: false,
      loadingApiChecksSatatus: false,
      isNewUser: null,
      userTypeId: null,
      existingUserInfo: null,
      componentTwoKey: 0,
      wizardButtonValue: toUpper(this.$t('common.signIn')),
      isCheckinFormInvalid: true,
      newUserInfo: null,
      loadSiteAndAreaComponent: false,
    };
  },
  computed: {
    ...mapGetters("visit", ["getIsQuickSignInSubmitClicked"]),
    ...mapGetters("i18N", ["getLanguage"]),

    wizardRef() {
      return this.$refs.quick_signin_wizard;
    },
  },
  methods: {
    ...mapActions("visit", ["submitQuickSignIn"]),

    userCheckinFormInvalid(isInvalid) {
      this.isCheckinFormInvalid = isInvalid;
    },
    setWizardButtonValue(buttonValue) {
      this.wizardButtonValue = buttonValue;
    },
    navigateToUserForm(currentActiveTabIndex) {
      this.wizardRef.changeTab(currentActiveTabIndex, 0);
      this.wizardButtonValue = toUpper(this.$t('common.signIn'))
      this.componentTwoKey++;
    },
    isUserFormInvalid(isInvalid) {
      this.isUserFormInvalidFlag = isInvalid;
    },
    apiChecksLoading(loadingStatus) {
      this.loadingApiChecksSatatus = loadingStatus;
    },
    setIsNewUser(isNewUser) {
      this.isNewUser = isNewUser;
    },
    setExisintgUserInfo(userInfo) {
      this.existingUserInfo = userInfo;
    },
    setNewUserInfo(userInfo) {
      this.newUserInfo = userInfo;
    },
    onSubmitForm(activeTabIndex) {
      if (activeTabIndex <= 0) return;
      this.submitQuickSignIn(true);
    },
    toggleLoadSiteAndAreaComponentFlag(type, currentIndex) {
      if (type == "next" && currentIndex == 1) return;
      this.loadSiteAndAreaComponent = !this.loadSiteAndAreaComponent;
    },
    signInOutFormSubmitted() {
      this.$emit("submitted", true);
    },
  },
  beforeMount() {
    this.savedLang = this.getLanguage ?? "en";
    this.submitQuickSignIn(false);
  },
};
</script>

<style lang="scss">
.quick-signin-wizard {
  padding: 0;
  position: relative;
  .wizard-progress-with-circle {
    display: none;
  }

  .wizard-tab-content {
    position: relative !important;
  }
  .wizard-nav.wizard-nav-pills:first-of-type {
    display: none;
  }
  .wizard-tab-content,
  .wizard-card-footer {
    padding: 0 !important;
  }
  .wizard-card-footer {
    .wizard-btn.next-btn:disabled {
      background-color: transparent !important;
      border: none !important;
      cursor: not-allowed;
      opacity: 0.4 !important;
    }
  }

  button.wizard-btn.sign-in-btn:disabled {
    opacity: 1 !important;
    background: #9fb2bf !important;
    cursor: not-allowed;
  }
  button.wizard-btn.sign-in-btn {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;

    text-align: center;
    letter-spacing: 0.25px;
    height: 44px;
    border: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #ffffff;
    border-radius: 22px;
    margin: 0px !important;
    padding: 0px !important;
    background-color: #103f5e;
  }
  .back-btn {
    background-color: #103f5e;
    border-radius: 50%;
    border: none !important;
    padding: 6px 0 !important;
    width: 44px !important;
    min-width: unset !important;
  }
}
</style>
